const TYPES: {
  label: string;
  href: string;
}[] = [
  {
    label: 'All',
    href: '/resources',
  },
  {
    label: 'Blog posts',
    href: '/blog',
  },
  {
    label: 'Guides',
    href: '/guides',
  },
  {
    label: 'Unlock Summit',
    href: '/unlock',
  },
  {
    label: 'Webinars',
    href: '/webinars',
  },
  {
    label: 'Videos',
    href: '/videos',
  },
];

export default TYPES;
